export enum BUTTON_TYPES {
  PRIMARY_0 = 'primary-0',
  PRIMARY_1 = 'primary-1',
  DESTRUCTIVE_0 = 'destructive-0',
  DESTRUCTIVE_1 = 'destructive-1',
  SECONDARY_0 = 'secondary-0',
  SECONDARY_1 = 'secondary-1',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  SEE_ALL = 'see-all'
}


export enum BUTTON_SIZE {
  SLIM = 'slim',
  FULL_SIZE = 'full-size'
}
